import React from "react";
import { Layout, Menu } from "antd";
import { withAlert } from "react-alert";
import FooterTemplate from "./landing/templates/FooterTemplate";
import ContentContainer from "../containers/templates/ContentContainer";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import LoginContainer from "../containers/LoginContainer";
import SiderTemplate from "./landing/templates/SiderTemplate";
import history from "../history";

const { SubMenu } = Menu;

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      draw: false,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log(prevProps);
  }

  render() {
    const store = this.props.store.getState();
    return (
      <Layout style={{ minHeight: "100vh" }}>
        <Switch>
          <Route exact path="/login" component={LoginContainer} />
          {store.auth.authenticated ? null : <Redirect to={"/login"} />}
          <Route
            render={() => {
              return (
                <>
                  <SiderTemplate history={history} />
                  <Layout>
                    <ContentContainer />
                    <FooterTemplate />
                  </Layout>
                </>
              );
            }}
          />
        </Switch>
      </Layout>
    );
  }
}

export default withRouter(withAlert(App));